import React, { createContext } from "react";
export const ExecutionContext = createContext("web");
export const ExecutionContextProvider = ({ context = "storybook", children }) => (React.createElement(ExecutionContext.Provider, { value: context }, children));
//# sourceMappingURL=ExecutionContextProvider.js.map